export default {
  methods: {
    initPaypalContainer(cta, containerId, cb = null) {
      if (typeof paypal === 'undefined') {
        return
      }

      paypal.Buttons({
        createOrder: (data, actions) => {
          return actions.order.create({
            purchase_units: [{
              amount: {
                value: cta.data.payments_price,
              },
            }],
          })
        },
        onApprove: (data, actions) => {
          return actions.order.capture().then(() => {
            switch (cta.data.payments_complete_action) {
              case this.constants.App_Models_CallToAction.COMPLETE_ACTION_URL:
                location.href = cta.data.payments_complete_url
                break
              case this.constants.App_Models_CallToAction.COMPLETE_ACTION_MESSAGE:
                window.SwalTimer.fire({
                  icon: 'success',
                  title: cta.data.payments_complete_message,
                })
                break
            }
            cb && cb()
          })
        },
      }).render(containerId)
    },
  },
}
